import { render } from "./ModalAdicionarProduto.vue?vue&type=template&id=232a0040&scoped=true"
import script from "./ModalAdicionarProduto.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarProduto.vue?vue&type=script&lang=js"

import "./ModalAdicionarProduto.vue?vue&type=style&index=0&id=232a0040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232a0040"]])

export default __exports__